/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The currency every money figure in the response is stated in, taken from
 * where the carrier is based. Stored amounts are Canadian dollars; a US
 * carrier's figures are converted back at the same rate they were
 * converted in at, so they match the carrier's own invoices.
 *
 * @export
 */
export const PortalCurrency = {
  Cad: "CAD",
  Usd: "USD",
} as const;
export type PortalCurrency =
  (typeof PortalCurrency)[keyof typeof PortalCurrency];

export function instanceOfPortalCurrency(value: any): boolean {
  for (const key in PortalCurrency) {
    if (Object.prototype.hasOwnProperty.call(PortalCurrency, key)) {
      if (PortalCurrency[key as keyof typeof PortalCurrency] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PortalCurrencyFromJSON(json: any): PortalCurrency {
  return PortalCurrencyFromJSONTyped(json, false);
}

export function PortalCurrencyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PortalCurrency {
  return json as PortalCurrency;
}

export function PortalCurrencyToJSON(value?: PortalCurrency | null): any {
  return value as any;
}

export function PortalCurrencyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): PortalCurrency {
  return value as PortalCurrency;
}
